export const WidthFormatter = (width) => {
    const widths = {
        totalPrice: '200px',
        qty: '130px'
    };

    return {
        width: widths[width]
    };
};
